module.exports = __webpack_public_path__ + "static/img/b1.8411542.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/b1.png
// module id = JdDL
// module chunks = 0